<app-common-offcanvas
  class="transaction-details"
  width="80vw"
  [opened]="opened()"
  (close)="closeOffcanvas()"
>
  <div class="header px-4">
    <h2 class="h2-heading m-0 p-0">
      Transactions Details
    </h2>
  </div>

  <div class="content-wrapper">
    <div class="content">
      <div class="transaction-date-status info">
        <div class="info">
          <div class="title">Date & Time</div>
          <div class="value">
            {{ transactionRecord?.createdOn| date : 'dd MMM yyyy HH:mm:ss' : 'en-US' }}
          </div>
        </div>

        <div class="info">
          <div class="title">Status</div>
          <div class="value">
            <span>{{ EdgeTransactionStatus[transactionRecord?.status!] }}</span>
          </div>
        </div>
      </div>

      <div class="transaction-preview-wrapper preview-wrapper">
        <pre>{{ transactionText }}</pre>
      </div>
    </div>

    <div class="controls">
      <button
        type="button"
        class="btn btn-secondary d-flex align-items-center gap-2"
        [disabled]="isActionLoading()"
        (click)="downloadTransaction()"
      >
        <i class="icon ic-download-20"></i>
        <span>Download</span>
      </button>

      @if (transactionRecord?.direction == EdgeTransactionDirection.Inbound) {
        <button
          type="button"
          class="btn btn-secondary d-flex align-items-center gap-2"
          [disabled]="isActionLoading()"
          (click)="reprocessTransaction()"
        >
          <i class="icon icon ic-refresh-20"></i>
          <span>Reprocess</span>
        </button>
      }
    </div>
  </div>
</app-common-offcanvas>
